module.exports = __webpack_public_path__ + "media/7.d697ef96.wav";